export default "__VITE_ASSET__bda67645__"